import React from 'react';
import bannerImage from '@/assets/dummies/banner_zirodelta.png';
import { Skeleton } from '@/components/ui/skeleton';
import usePartner from '@/hooks/usePartner';

function Header() {
    const { data: partner, isLoading } = usePartner();

    if (isLoading) {
        return (
            <div className='mt-[2.88rem]'>
                <Skeleton className='w-full h-[12.5rem]' />
            </div>
        );
    }

    return (
        <div className='xl:px-8'>
            <div className='w-full overflow-hidden'>
                {/* Mobile banner (< 768px) */}
                <img
                    src={partner?.bannerMobile || bannerImage}
                    alt={`${partner?.name || 'Partner'} Banner`}
                    className='w-full h-[132px] object-cover object-right md:hidden'
                    loading='lazy'
                />

                {/* Tablet banner (>= 768px and < 1400px) */}
                <img
                    src={partner?.bannerTablet || bannerImage}
                    alt={`${partner?.name || 'Partner'} Banner`}
                    className='w-full h-[200px] object-cover object-right hidden md:block 2xl:hidden'
                    loading='lazy'
                />

                {/* Desktop banner (>= 1400px) */}
                <img
                    src={partner?.bannerDesktop || bannerImage}
                    alt={`${partner?.name || 'Partner'} Banner`}
                    className='w-full h-[200px] object-cover object-right hidden 2xl:block'
                    loading='lazy'
                />
            </div>
        </div>
    )
};

export default Header;